import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a7265d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-container" }
const _hoisted_2 = { class: "d-flex dasboard-header" }
const _hoisted_3 = { class: "dashboard-header-item" }
const _hoisted_4 = { class: "dashboard-header-menus" }
const _hoisted_5 = { class: "dashboard-header-filters" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = {
  class: "filter-btn",
  type: "button",
  id: "dropdownMenuClickableInside",
  "data-bs-toggle": "dropdown",
  "data-bs-auto-close": "outside",
  "aria-expanded": "false"
}
const _hoisted_8 = { class: "scroll-container" }
const _hoisted_9 = {
  key: 0,
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuClickableInside"
}
const _hoisted_10 = ["for"]
const _hoisted_11 = {
  key: 1,
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuClickableInside"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "dropdown-item" }, "Sem filtros disponíveis")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "filter-date"
}
const _hoisted_15 = {
  key: 1,
  class: "filter-date"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "dataInicio",
  class: "label-date"
}, "Inicial: ", -1))
const _hoisted_17 = {
  key: 2,
  class: "filter-date"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "dataFim",
  class: "label-date"
}, "Final: ", -1))
const _hoisted_19 = { class: "input-wrapper" }
const _hoisted_20 = { class: "tooltip-wrapper" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scroll-container" }, "Aplicar Filtros", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "tooltip-balloon-bottom"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scroll-container" }, "Limpar Filtros", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 3,
  class: "date"
}
const _hoisted_28 = { class: "dashboard-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_checkbox_component = _resolveComponent("checkbox-component")!
  const _component_DropdownComponent = _resolveComponent("DropdownComponent")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
            return (_openBlock(), _createElementBlock("div", {
              key: filter.name,
              class: "filter-content"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(filter.name + _ctx.countfilters(filter.data)), 1),
                  _createVNode(_component_BaseIcon, {
                    name: "chevron-down-dark",
                    size: "8px"
                  })
                ]),
                (_ctx.getFilter(filter.data))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilter(filter.data), (option) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: `${filter.data}-${option.id}`,
                          class: "li-item"
                        }, [
                          _createElementVNode("label", {
                            for: `${filter.data}-${option.id}`,
                            class: "dropdown-item"
                          }, [
                            _createTextVNode(_toDisplayString(option.fullname) + " ", 1),
                            _createVNode(_component_checkbox_component, {
                              checked: option.selected,
                              onChanged: ($event: any) => (_ctx.changeSearchParams(filter.data, option.id)),
                              checkboxid: `${filter.data}-${option.id}`
                            }, null, 8, ["checked", "onChanged", "checkboxid"])
                          ], 8, _hoisted_10)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_11, _hoisted_13))
              ])
            ]))
          }), 128)),
          (_ctx.listFilterSelected.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_DropdownComponent, {
                  ref: "dropdown",
                  prop_options: _ctx.listFilterSelected,
                  onSelectOption: _cache[0] || (_cache[0] = (value) => _ctx.selectedFilter(value))
                }, null, 8, ["prop_options"]),
                (_ctx.activeFilter)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "text",
                      id: "SearchField",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.otherFilters[_ctx.activeFilter]) = $event)),
                      class: "form-control input-text"
                    }, null, 512)), [
                      [_vModelText, _ctx.otherFilters[_ctx.activeFilter]]
                    ])
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.filterOptions.date?.enabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "dataInicio",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.otherFilters.dateStart) = $event)),
                  class: "form-control input-date"
                }, null, 512), [
                  [_vModelText, _ctx.otherFilters.dateStart]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.filterOptions.date?.enabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "dataFim",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.otherFilters.dateEnd) = $event)),
                    class: "form-control input-date"
                  }, null, 512), [
                    [_vModelText, _ctx.otherFilters.dateEnd]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              class: "save-btn",
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.applySearchParams())),
              disabled: !!_ctx.disabledReason
            }, _hoisted_23, 8, _hoisted_21),
            (_ctx.disabledReason)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.disabledReason), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "clear-btn",
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearFilters()))
          }, _hoisted_26),
          (_ctx.showCurrentDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.currentFormattedDate), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(_component_router_view)
    ])
  ]))
}